import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { Box } from '@mui/material'

import { TextInput } from '../../../../ui'
import { ConfirmationDialog } from '../../../../ui/dialogs'

export const MotiveDialog = ({ close, onConfirm, email }) => {
  const { formatMessage } = useIntl()
  const [motive, setMotive] = useState('')

  const handleChangeForm = (event) => {
    setMotive(event.target.value)
  }

  return (
    <ConfirmationDialog
      title={formatMessage({ id: 'pages.emailManagement.motiveDialog.title' })}
      text={formatMessage({ id: 'pages.emailManagement.motiveDialog.message' }, { email })}
      yesText={formatMessage({ id: 'global.confirm' })}
      noText={formatMessage({ id: 'global.cancel' })}
      yesAction={() => {
        onConfirm(motive.trim())
      }}
      noAction={() => {}}
      close={close}
      awaiting={false}
    >
      <Box mt={2}>
        <TextInput
          value={motive}
          name="motive"
          title={formatMessage({ id: 'pages.emailManagement.motiveDialog.motiveLabel' })}
          placeholder={formatMessage({
            id: 'pages.emailManagement.motiveDialog.motivePlaceholder',
          })}
          onChange={handleChangeForm}
          fullWidth
        />
      </Box>
    </ConfirmationDialog>
  )
}
